import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Chip } from '../../components/chips/Chip';
import { Hyperlink } from '../../components/Hyperlink';

type Props = {
  count: number;
  href?: string;
};

export const TimelineChip: FC<Props> = ({ count, href }) => {
  return href ? (
    <Chip
      color="primary"
      href={`${href}#decision_timeline`}
      component={Hyperlink}
      target="_blank"
    >
      <FormattedMessage id="TimelineChip" values={{ count }} />
    </Chip>
  ) : (
    <Chip color="primary">
      <FormattedMessage id="TimelineChip" values={{ count }} />
    </Chip>
  );
};
